import React, { useState, useEffect } from 'react';
import PrimaryButton from '../../../components/Buttons/PrimaryButton';
import useApp from '../../../store/app/appContext';
import useUsers from '../../../store/users/usersContext';
import useNotification from '../../../store/notification/notificationContext';
import RenderQuestion from './RenderQuestion';
import useWindowSize from '../../../hooks/useWindowSize';
import { NOTIFICATIONS } from '../../../config';

function QuestionnaireForm({ setCurrentStep }) {

  const windowSize = useWindowSize(); 

  const {
    getAllMedicalQuestionnaire,
  } = useApp();

  const { getPatientInfo } = useUsers();

  const [medicalQuestionnaire, setMedicalQuestionnaire] = useState();
  const [patientInfo, setPatientInfo ] = useState();

  React.useEffect(() => {
    getAllMedicalQuestionnaire().then((data) => {
      data = data.sort((a,b) => a.id - b.id)
      setMedicalQuestionnaire(data);
    });

    getPatientInfo().then((data) => {
      setPatientInfo(data);
    });
  }, []);

  const { setNotification } = useNotification();
  const { addPatientInfo, updatePatientInfo } = useUsers();

  const [answers, setAnswers] = useState();
  const [id, setId] = useState();
  const [step1Questions, setStep1Questions] = useState([]);
  const [step2Questions, setStep2Questions] = useState([]);

  React.useEffect(() => {
    medicalQuestionnaire && setStep1Questions(medicalQuestionnaire.filter((q) => !q.question_group));
    medicalQuestionnaire && setStep2Questions(medicalQuestionnaire.filter((q) => q.question_group));
  }, [medicalQuestionnaire])

  useEffect(() => {
    if (patientInfo && patientInfo.question_answers) {
      setId(patientInfo._id);
      patientInfo.question_answers.length ? setAnswers(patientInfo.question_answers) : setInitialAnswers() 
    }
    else {
      setInitialAnswers()
    }
  }, [medicalQuestionnaire, patientInfo]);

  const setInitialAnswers = () => {
    if (medicalQuestionnaire && !answers) {
      let initialanswers = medicalQuestionnaire.map((q) => {
        return {
          question_id: q.id,
          answer: q.question_type === "multiple" ? [] : null,
          value: null,
        };
      });
      setAnswers(initialanswers);
    }
  }

  const handleNext = () => {
    let completed = getStatus(step1Questions);
    if (!completed) return  showNotification();
    completed = getStatus(step2Questions);
    if (!completed) return  showNotification();
    if (id) updatePatientInfo(answers); //if Id, then user already has previous answers, so update instead of add
    if (!id) addPatientInfo(answers);
    setCurrentStep('2');
    return;
  };

  const getStatus = (questions) => {
    let completed = true;
    questions.map((q) => {
      let matched = answers.filter((a) => a.question_id == q.id)[0];
      if (matched.answer === null || matched.answer === "") {
        completed = false;
      }
    });
    return completed;
  };

  const showNotification = () => {
    setNotification({
      show: true,
      type: NOTIFICATIONS.TYPE.WARNING_YELLOW,
      title: "Error",
      message: "Please answer all the questions",
    });
  };

  const setAnswer = (question, value) => {
    let updated = answers.map((answer) => {
      if (answer.question_id === question.id) {
        if (question.question_type === "multiple") {
          if (answer.answer.includes(value)) {
            answer.answer = answer.answer.filter((a) => a !== value);
          } else {
            answer.answer.push(value);
          }
        } else {
          answer.answer = value;
        }
      }
      return answer;
    });
    setAnswers(updated);
  };

  const setAdditionalValue = (anwerDetails, value) => {
    let updated = answers.map((a) => {
      if (a.question_id === anwerDetails.question_id) {
        a.value = value;
      }
      return a;
    });
    setAnswers(updated);
  };


  return (
  <div className="h-full  flex  flex-col justify-between">
    <div className="pt-4 flex flex-col overflow-y-auto justify-between w-full px-12" style={{ height: windowSize.width > windowSize.tailwind.md ? '580px' : '342px' }}>
        <div className="">
          {
            step1Questions &&
            step1Questions.map((question, index) => {
              let data =
                answers && answers.find((a) => a.question_id === question.id);
              return (
                <RenderQuestion
                  data={question}
                  index={index}
                  answerData={data}
                  setAnswer={setAnswer}
                  setAdditionalValue={setAdditionalValue}
                />
              );
            })}

          <div className="my-2 font-medium">6. Do you suffer from following issues?</div>
          {
            step2Questions &&
            step2Questions.map((question, index) => {
              let data =
                answers && answers.find((a) => a.question_id === question.id);
              return (
                <RenderQuestion
                  data={question}
                  index={index}
                  answerData={data}
                  setAnswer={setAnswer}
                  setAdditionalValue={setAdditionalValue}
                  questionGroup={true}
                />
              );
            })}
        </div>
      </div>
      <div className="flex">
        <div className={"w-full"}>
          <PrimaryButton
            onClick={handleNext}
            className="mt-8"
            large
            text="NEXT"
          />
        </div>
      </div>
  </div>
  )
}

export default QuestionnaireForm;
